<template>
    <div class="flex flex-col pb-2">
        <!-- <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                PC {{ contactNumber }}
            </div>
        </div> -->
        <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                Name:
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="pl-0">
                {{ contactFullName }}
            </div>
        </div>
        <div class="flex w-full justify-between pb-2">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                Title:
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="pl-0">
                {{ contactTitle }}
            </div>
        </div>
        <div class="flex w-full justify-between pb-2">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                TZ:
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="pl-0">
                {{ contactTimeZone }}
            </div>
        </div>
        <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                <CopyField
                    v-if="businessEmail!=''"
                    :copy-source="businessEmail"
                >
                    Biz EM:
                </CopyField>
                <div v-else>
                    Biz EM:
                </div>
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="flex pl-0 items-center">
                <div>
                    {{ businessEmail }}
                </div>
            </div>
        </div>
        <div class="flex w-full justify-between pb-2">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                <CopyField
                    v-if="businessPhone!=''"
                    :copy-source="businessPhone"
                >
                    Biz PH:
                </CopyField>
                <div v-else>
                    Biz PH:
                </div>
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="pl-0">
                {{ businessPhone }}
            </div>
        </div>
        <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                <CopyField
                    v-if="personalEmail!=''"
                    :copy-source="personalEmail"
                >
                    Pers EM:
                </CopyField>
                <div v-else>
                    Pers EM:
                </div>
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="pl-0">
                {{ personalEmail }}
            </div>
        </div>
        <div class="flex w-full justify-between pb-2">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                <CopyField
                    v-if="personalPhone!=''"
                    :copy-source="personalPhone"
                >
                    Pers PH:
                </CopyField>
                <div v-else>
                    Pers PH:
                </div>
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="pl-0">
                {{ personalPhone }}
            </div>
        </div>
        <div v-if="linkedInURL" class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                <CopyField
                    :copy-source="linkedInURL"
                >
                    LinkedIn:
                </CopyField>
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="break-all line-clamp-1 text-indigo-500 hover:underline hover:text-dark-secondary pl-0">
                <a :href="`https://www.linkedin.com/${linkedInURL}`" target="_blank" class="text-indigo-500 hover:underline hover:text-dark-secondary">{{ linkedInURL }}</a>
            </div>
        </div>
        <div v-else class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                LinkedIn:
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="pl-0">
                
            </div>
        </div>
        <div class="flex flex-col w-full ">
            <div v-if="contactNotes && expandedRow">
                <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800">
                    Notes:
                </div>
                <div  class="whitespace-pre-wrap break-all">
                    {{ contactNotes }}
                </div>
            </div>
            <div v-else-if="contactNotes" class="flex w-full justify-between">
                <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800">
                    Notes:
                </div>
                <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
                <div class="whitespace-pre-wrap line-clamp-1 break-all">
                    {{ contactNotes }}
                </div>
            </div>
            <div v-else class="flex w-full justify-between ">
                <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                    Notes:
                </div>
                <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
                <div class="pl-0">
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue';
import CopyField from '../base-components/CopyField.vue';

const props = defineProps(['index', 'contact', 'expandedRow'])

const contactNumber = computed(() => {
    return props.index != undefined ? props.index + 1 : null
})


const contactFullName = computed(() => {
    let fullName = ''
    if(props.contact.contact.prefix){
        fullName += `${props.contact.contact.prefix} `
    }
    if(props.contact.contact.first_name){
        fullName += `${props.contact.contact.first_name} `
    }
    if(props.contact.contact.middle_name){
        fullName += `${props.contact.contact.middle_name} `
    }
    if(props.contact.contact.last_name){
        fullName += `${props.contact.contact.last_name}`
    }
    if(props.contact.contact.suffix){
        fullName += ` ${props.contact.contact.suffix}`
    }
    if(props.contact.contact.preferred_name) {
        fullName += ` (${props.contact.contact.preferred_name})`
    }
    if(fullName !== '') {
        return fullName
    } else {
        return ''
    }
})

const contactTimeZone = computed(() => {
    if(props.contact){
        return props.contact.time_zone ? props.contact.time_zone : ""
    } else {
        return ""
    }
})

const contactTitle = computed(() => {
    if(props.contact) {
        return props.contact.title ? props.contact.title : 'None'
    }
    return ''
})

const businessEmail = computed(() => {
    if(props.contact) {
        return props.contact.email_address ? props.contact.email_address : '--'
    }
    return ''
})

// const businessEmailIsVerified = computed(() => {
//     if(
//         props.contact && 
//         props.contact.company_relationships && 
//         props.contact.company_relationships.filter(relationship => relationship.company_id == props.company.id).length > 0
//     ) {
//         return props.contact.company_relationships.filter(relationship => relationship.company_id == props.company.id)[0].email_address ? props.contact.company_relationships.filter(relationship => relationship.company_id == props.company.id)[0].is_verified : false
//     }
//     return ''
// })

const businessPhone = computed(() => {
    if(props.contact) {
        return props.contact.phone_number ? props.contact.phone_number : "--"
    }
    return ''
})

const contactNotes = computed(() => {
    if(props.contact){
        return props.contact.contact_notes ? props.contact.contact_notes : "--"
    }
    return "--"
})

const personalEmail = computed(() => {
    return props.contact.contact.personal_email ? props.contact.contact.personal_email : ''
})

const personalPhone = computed(() => {
    return props.contact.contact.personal_phone ? props.contact.contact.personal_phone : ''
})

const linkedInURL = computed(() => {
    return props.contact.contact.linkedin_profile ? props.contact.contact.linkedin_profile.replace('https://www.linkedin.com/', '') : null
})

</script>